const commonActions = {
  SET_ALERT: 'SET_ALERT',
  SET_PAGE_LOADER : 'SET_PAGE_LOADER',
  SET_BUTTON_LOADER : 'SET_BUTTON_LOADER',
  SET_SHOW_MODAL: 'SET_SHOW_MODAL',
}

export default commonActions;
